import type { SvgIconComponent } from "@mui/icons-material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Tooltip } from "@mui/material";
import { HiddenDescription } from "./DescribedTooltip.tsx";

function stringWithLinebreaks(str: string) {
  return str.split("\n").map((line, i) => (
    <span key={i}>
      {line}
      {i !== str.split("\n").length - 1 && <br />}
    </span>
  ));
}

interface InfoTooltipProps {
  helpertext: string;
  ariaDescribedById: string;
  icon?: SvgIconComponent;
}

/**
 * Shows a field's help on hovering a decorative icon in its label. As the
 * icon is part of the label, the help is the field's description instead.
 */
export function InfoToolTip({
  helpertext,
  ariaDescribedById,
  icon: Icon = InfoOutlinedIcon,
}: InfoTooltipProps) {
  return (
    <>
      <Tooltip title={stringWithLinebreaks(helpertext)}>
        <Icon
          fontSize="small"
          sx={{ ml: 0.5, verticalAlign: "middle", cursor: "pointer" }}
        />
      </Tooltip>
      <HiddenDescription id={ariaDescribedById}>{helpertext}</HiddenDescription>
    </>
  );
}
